// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout{
    display: flex;
    max-width: 100vw;
}
p {

  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
}

body {
    overflow: hidden; 
  }
  
  .content {
 
    width: 100%;
    height: 100%;
    overflow: auto; 
  }
  
  
  .content::-webkit-scrollbar {
    width: 0;
  }

  
  .menu{
    width: 35px;
    height:35px;
    background-color: red;
  }

  .menu img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  
 
@media screen and (min-width:768px) {
  .menu{
    display: none;
  }

}

.sidebar {
    width: 250px;
    flex-shrink: 0;
    background-color: #333;
    color: #fff;
    overflow-y: auto; /* Allow sidebar to scroll */
    height: 100vh; /* Ensure sidebar takes full height of viewport */
}

.logo {
    margin: 20px;
}

.sidebar-item {
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.sidebar-item:hover {
    background-color: #555;
}

.sidebar-title {
    display: flex;
    align-items: center;
}

.sidebar-content {
    padding-left: 20px;
}

.sidebar-item .plain {
    text-decoration: none;
    color: white;
}

.toggle-btn {
    cursor: pointer;
    margin-left: auto;
}

.sidebar-item.open {
    background-color: #555;
}

/* Main content area */
.main-content {
    flex-grow: 1;
    padding: 20px;
    overflow-y: auto; /* Allow main content to scroll */
}

/* Styling for members section */
.member-container {
    margin-top: 20px;
}

.member-item {
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 10px;
}

.member-item h4 {
    margin-bottom: 5px;
    font-weight: bold;
}

.member-item p {
    margin-bottom: 3px;
    font-size: 14px;
    color: #666;
}

/* Optional: Add hover effect */
.member-item:hover {
    background-color: #f0f0f0;
}

/* Media query for responsive layout */
@media screen and (max-width: 768px) {
    .container {
        flex-direction: column; /* Stack sidebar on top of main content on small screens */
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;;EAEE,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;IACI,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;;EAGA;IACE,QAAQ;EACV;;;EAGA;IACE,WAAW;IACX,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;;AAGF;EACE;IACE,aAAa;EACf;;AAEF;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,gBAAgB,EAAE,4BAA4B;IAC9C,aAAa,EAAE,iDAAiD;AACpE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB,EAAE,iCAAiC;AACvD;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;AAC7B;;AAEA,sCAAsC;AACtC;IACI;QACI,sBAAsB,EAAE,0DAA0D;IACtF;AACJ","sourcesContent":[".layout{\r\n    display: flex;\r\n    max-width: 100vw;\r\n}\r\np {\r\n\r\n  margin-block-start: 1em;\r\n  margin-block-end: 1em;\r\n  margin-inline-start: 10px;\r\n  margin-inline-end: 10px;\r\n}\r\n\r\nbody {\r\n    overflow: hidden; \r\n  }\r\n  \r\n  .content {\r\n \r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: auto; \r\n  }\r\n  \r\n  \r\n  .content::-webkit-scrollbar {\r\n    width: 0;\r\n  }\r\n\r\n  \r\n  .menu{\r\n    width: 35px;\r\n    height:35px;\r\n    background-color: red;\r\n  }\r\n\r\n  .menu img{\r\n    width: 100%;\r\n    height: 100%;\r\n    cursor: pointer;\r\n  }\r\n  \r\n \r\n@media screen and (min-width:768px) {\r\n  .menu{\r\n    display: none;\r\n  }\r\n\r\n}\r\n\r\n.sidebar {\r\n    width: 250px;\r\n    flex-shrink: 0;\r\n    background-color: #333;\r\n    color: #fff;\r\n    overflow-y: auto; /* Allow sidebar to scroll */\r\n    height: 100vh; /* Ensure sidebar takes full height of viewport */\r\n}\r\n\r\n.logo {\r\n    margin: 20px;\r\n}\r\n\r\n.sidebar-item {\r\n    padding: 10px;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.sidebar-item:hover {\r\n    background-color: #555;\r\n}\r\n\r\n.sidebar-title {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.sidebar-content {\r\n    padding-left: 20px;\r\n}\r\n\r\n.sidebar-item .plain {\r\n    text-decoration: none;\r\n    color: white;\r\n}\r\n\r\n.toggle-btn {\r\n    cursor: pointer;\r\n    margin-left: auto;\r\n}\r\n\r\n.sidebar-item.open {\r\n    background-color: #555;\r\n}\r\n\r\n/* Main content area */\r\n.main-content {\r\n    flex-grow: 1;\r\n    padding: 20px;\r\n    overflow-y: auto; /* Allow main content to scroll */\r\n}\r\n\r\n/* Styling for members section */\r\n.member-container {\r\n    margin-top: 20px;\r\n}\r\n\r\n.member-item {\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.member-item h4 {\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n}\r\n\r\n.member-item p {\r\n    margin-bottom: 3px;\r\n    font-size: 14px;\r\n    color: #666;\r\n}\r\n\r\n/* Optional: Add hover effect */\r\n.member-item:hover {\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n/* Media query for responsive layout */\r\n@media screen and (max-width: 768px) {\r\n    .container {\r\n        flex-direction: column; /* Stack sidebar on top of main content on small screens */\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
